import React from 'react';
import { Popconfirm } from 'antd';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { safeExtractFromObject } from '../../helpers/helpers';

const OntraccrPopconfirm = React.forwardRef(({
  children,
  ...props
}, ref) => {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;

  return (
    <Popconfirm
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      ref={ref}
      okButtonProps={{
        className: hasRedesign ? 'button-redesign-primary' : '',
      }}
      cancelButtonProps={{
        className: hasRedesign ? 'button-redesign-cancel' : '',
      }}
    >
      {children}
    </Popconfirm>
  );
});

OntraccrPopconfirm.propTypes = {
  children: PropTypes.node.isRequired,
};

export default OntraccrPopconfirm;
